import { Loading } from 'adc-ui-components';
import React, { useEffect } from 'react';

const LoadingWrapper = () => {
  useEffect(() => {
    document.body.classList.add('maw-devices--ready');
  }, []);
  return <Loading />;
};

export default LoadingWrapper;
